import gsap from 'gsap'
import { runExitAnimation } from '@/views/situationRoom/animation/runExit.js'

export function runLoadingAnimation () {
  return new Promise((resolve) => {
    const hasRunAnimation = sessionStorage.getItem('hasRunLoadingAnimation')
    if (hasRunAnimation) {
      const loading = document.querySelector('.loading-screen')
      const situation = document.querySelector('.situationRoom')

      if (loading) loading.style.display = 'none'
      if (situation) situation.style.transform = 'translateY(0%)'

      resolve()
      return
    }

    sessionStorage.setItem('hasRunLoadingAnimation', 'true')

    const tl = gsap.timeline({ onComplete: resolve })

    const loadingText = document.querySelector('.loading-text')
    const loadBar = document.querySelector('.loadBox-1')
    const logo = document.querySelector('.logo')
    const container = document.querySelector('.loadBoxG')
    const maxWidth = container ? container.clientWidth : 300

    let percent = { value: 0 }

    const blinkTween = gsap.to('.loadBoxG', {
      opacity: 0,
      duration: 0.5,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    })

    tl.to(logo, {
      opacity: 1,
      scale: 1,
      duration: 1,
      ease: 'power2.out'
    })

    tl.to(percent, {
      value: 100,
      duration: 5,
      ease: 'power2.inOut',
      onUpdate: () => {
        const currentPercent = Math.round(percent.value)
        loadingText.textContent = `${currentPercent}%`
        loadBar.style.width = `${(currentPercent / 100) * maxWidth}px`
      },
      onComplete: () => {
        blinkTween.kill()
        gsap.to('.loadBoxG', { opacity: 1 })
      }
    })

    tl.call(() => runExitAnimation(resolve))
  })
}
